import * as types from '../../types';

const initialData = {
  rankingReportData: {
    name: '',
    reportOnPortfolioModels: false,
    overwriteLastDataDate: false,
    overwriteLastVintageDate: false,
    enableSpecUpdate: false,
    oneOffRun: false,
    useHistoricalLearning: true,
    selectedModels: [],
    spec: {
      useHistoricalLearning: true,
    },
  },
  models: {},
};

const rankingReportReducer = (state = initialData, action) => {
  switch (action.type) {
    case types.USER_LOGOUT:
      return initialData;
    case types.RANKING_REPORTING_OUTPUT_SAVE_DATA: {
      return {
        ...state,
        rankingReportData: {
          ...action.payload,
        },
      };
    }
    case types.RANKING_REPORTING_OUTPUT_SAVE_DATA_IN_STATE: {
      return {
        ...state,
        rankingReportData: {
          ...action.payload,
        },
      };
    }
    case types.RANKING_REPORTING_OUTPUT_LOAD_DATA: {
      return {
        ...state,
        rankingReportData: {
          ...action.payload,
        },
      };
    }
    case types.RANKING_REPORTING_OUTPUT_RESET: {
      return {
        ...state,
        rankingReportData: {
          ...initialData.rankingReportData,
        },
      };
    }
    case types.RANKING_REPORTING_OUTPUT_UPDATE_SELECTED_MODELS: {
      return {
        ...state,
        rankingReportData: {
          ...state.rankingReportData,
          selectedModels: [...action.payload],
        },
      };
    }
    case types.RANKING_REPORTING_OUTPUT_UPDATE_MODELS: {
      let models = {};
      models[action.payload.specModel] = action.payload.models;

      return {
        ...state,
        models: {
          ...state.models,
          ...models,
        },
      };
    }

    default:
      return state;
  }
};

export default rankingReportReducer;
